// extracted by mini-css-extract-plugin
export default {"subjects_view_tabs":"subjects-view-tabs_subjects_view_tabs__Xc9Fs"};